import React from 'react';

import { DynamicIconWrapper, Icons, Tooltip } from '@components/common';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { checkGroupPanelAccess } from '@utils/permissions';

import { mapGroupAccess } from '@constants/menuGroupAccess';
import { viewOnMapTooltip } from '@components/routes/AdminPanel/AssetProfile/constants';

import styles from './ActionsColumnCell.module.scss';

interface IActionsColumnCell {
	openProfileHandler: () => void;
	stopRentingAssetHandler: () => void;
	viewOnMapHandler: () => void;
	isStopRentAssetDisable: boolean;
	isViewAssetProfileDisabled: boolean;
}

const ActionsColumnCell = ({
	openProfileHandler,
	stopRentingAssetHandler,
	viewOnMapHandler,
	isStopRentAssetDisable,
	isViewAssetProfileDisabled,
}: IActionsColumnCell) => {
	const { accessPermission } = useAppSelector(auth);

	const isMapModuleAvailable = checkGroupPanelAccess(accessPermission, mapGroupAccess);
	const stopUsingAsset = () => {
		if (isStopRentAssetDisable) return;

		stopRentingAssetHandler();
	};

	const openAssetProfile = () => {
		if (isViewAssetProfileDisabled) return;

		openProfileHandler();
	};

	return (
		<div className={styles.cellContainer}>
			<Tooltip content='View asset profile'>
				<div
					className={styles.viewIcon}
					onClick={openAssetProfile}
				>
					<DynamicIconWrapper
						icon={Icons.viewIcon}
						isDisabled={isViewAssetProfileDisabled}
					/>
				</div>
			</Tooltip>
			{isMapModuleAvailable && (
				<Tooltip content={viewOnMapTooltip}>
					<div
						className={styles.locationIcon}
						onClick={viewOnMapHandler}
					>
						<DynamicIconWrapper icon={Icons.location} />
					</div>
				</Tooltip>
			)}
			<Tooltip content='Stop using asset'>
				<div
					className={styles.stopIcon}
					onClick={stopUsingAsset}
				>
					<DynamicIconWrapper
						icon={Icons.stopIcon}
						isDisabled={isStopRentAssetDisable}
					/>
				</div>
			</Tooltip>
		</div>
	);
};

export default ActionsColumnCell;
